module.exports = __webpack_public_path__ + "img/sova.64278d53.jpg";